import { Spinner } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { Select } from "antd";
import swal from "sweetalert";
import Axios from "axios";
import { useSelector } from "react-redux";

import TableComponent from "../../../../../_metronic/table/TableComponent";

const headers = [
  { label: "Product Name", key: "name" },
  { label: "Category Name", key: "category_name" },
  { label: "Code", key: "product_code" },
  { label: "Store Code", key: "store_code" },
  { label: "Quantity", key: "quantity" },
  { label: "Temp Qty", key: "temp_quantity" },
  { label: "Booked Qty", key: "booked_quantity" },
  { label: "MRP", key: "mrp" },
  { label: "MRP ex Vat", key: "mrp_excluding_vat" },
];

const headers2 = [
  { label: "Item", key: "item" },
  { label: "Dhanmondi", key: "Dhanmondi" },
  { label: "Uttara", key: "Uttara" },
];

const exdata = [
  { item: "Beef", Dhanmondi: "10", Uttara: "20" },
  { item: "Chicken", Dhanmondi: "10", Uttara: "20" },
  { item: "Paratha", Dhanmondi: "10", Uttara: "20" },
];

export default function LowStock() {
  const [searchLoading, setSearchLoading] = useState(false);
  const {menuType} = useSelector((state) => state.auth)
  const [pullLoading, setPullLoading] = useState(false);
  const [pullButtonShow, setPullButtonShow] = useState(false);

  const [storeDataSingle, setStoreDataSingle] = useState([]);
  const [storeWiseListData, setStoreWiseListData] = useState([]);
  const [count, setCount] = useState();

  const { Option } = Select;

  // Storing Multiple Products
  const [storesSingle, setStoresSingle] = useState();
  const [dataTable, setDataTable] = useState(false);

  // Token From State
  const {
    user: { accessToken, refreshToken },
  } = useSelector((state) => state.auth);
  // Token From State

  // 3- API Get No. of stores
  const getStoreData = async () => {
    const { data } = await Axios.post(
      `${process.env.REACT_APP_API_URL}/store/list`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
          refreshToken: refreshToken,
        },
      }
    );
    if (!data.error) {
      setStoreDataSingle(data.data);
    }
  };
  // 3- API Get No. of stores

  // 5- API Get store products storewise list Data
  const getStoresDetails = async () => {
    setSearchLoading(true);
    const { data } = await Axios.post(
      `${process.env.REACT_APP_API_URL}/product/productStockStoreWiseLowerFrom`,
      {
        store_id: storesSingle,
        lower_from: count,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
          refreshToken: refreshToken,
        },
      }
    );
    if (!data.error) {
      if (data.data.length == 0) {
        setDataTable(true);
        setPullButtonShow(false);
        swal({
          title: "No data found!",
          icon: "info",
        });
      } else {
        setStoreWiseListData(data.data);
        setDataTable(true);
        setPullButtonShow(true);
        setSearchLoading(false);
      }
    } else {
      swal({
        title: data.message,
        icon: "info",
      });
    }
  };
  // 5- API Get store products storewise list Data

  // 7- Stock Product Availability Update by Selected Store
  const getStockPrductAvailabilityUpdate = async () => {
    setPullLoading(true);
    const { data } = await Axios.get(
      `${process.env.REACT_APP_API_URL}/order-btoc/stockPrductAvailabilityUpdate/${storesSingle}/${menuType?.toLowerCase()}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
          refreshToken: refreshToken,
        },
      }
    );
    if (!data.error) {
      setPullLoading(false);
      setPullButtonShow(true);
      swal({
        title: data.message,
        icon: "success",
      });
      refetchStoresDetails();
    } else {
      setPullButtonShow(false);
      setPullLoading(false);
      swal({
        title: data.message,
        icon: "info",
      });
    }
  };
  // 7- Stock Product Availability Update by Selected Store

  // 8- Refetch Storewise List Data
  const refetchStoresDetails = async () => {
    const { data } = await Axios.get(
      `${process.env.REACT_APP_API_URL}/product/productListStoreWise/${storesSingle}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
          refreshToken: refreshToken,
        },
      }
    );
    if (!data.error) {
      if (data.data.length == 0) {
        setDataTable(true);
        setPullButtonShow(true);
        swal({
          title: "No data found!",
          icon: "info",
        });
      } else {
        setStoreWiseListData(data.data);
        setDataTable(true);
      }
    } else {
      swal({
        title: data.message,
        icon: "info",
      });
    }
  };
  // 8- Refetch Storewise List Data

  const searchStock = () => {
    getStoresDetails();
  };

  useEffect(() => {
    getStoreData();
  }, []);

  // React Table
  const data = React.useMemo(() => storeWiseListData, [storeWiseListData]);
  const columns = React.useMemo(() => [
    {
      Header: "#",
      accessor: (row, index) => (
        <div className="d-flex align-items-center pl-4">
          <div>
            <h4 className="text-dark-75 font-weight-bolder mb-1 font-size-sm">
              {index + 1}
            </h4>
          </div>
        </div>
      ),
      minWidth: 50,
      width: 50,
    },
    {
      Header: "Product name",
      paddingLeft: "10px",
      accessor: "name",
    },
    {
      Header: "Category name",
      accessor: "category_name",
      paddingLeft: "0px",
    },
    {
      Header: "Code",
      accessor: "product_code",
      paddingLeft: "0px",
    },
    {
      Header: "St. Code",
      accessor: "store_code",
      paddingLeft: "0px",
    },
    {
      Header: "QTY",
      accessor: "quantity",
      paddingLeft: "0px",
    },
    {
      Header: "Temp. QTY",
      accessor: "temp_quantity",
      paddingLeft: "0px",
    },
    {
      Header: "Booked QTY",
      accessor: "booked_quantity",
      paddingLeft: "0px",
    },
    {
      Header: "MRP",
      accessor: "mrp",
      paddingLeft: "0px",
    },
    {
      Header: "MRP Ex Vat",
      accessor: "mrp_excluding_vat",
      paddingLeft: "0px",
    },
  ]);

  return (
    <div className="card mt-10">
      {/* Section-2 Start*/}
      <div
        className="card-header border-0 d-flex justify-content-between pb-0"
        style={{ marginTop: -50 }}
      >
        <h3 className="card-title mb-5">Low Stock Products List</h3>
      </div>
      <div className="row px-10">
        <div className="col-md-4 my-5">
          <div className="d-flex" style={{ flexDirection: "column" }}>
            <label>Select Stores</label>
            <Select
              allowClear
              showSearch
              style={{ width: "100%" }}
              placeholder="Select One Store"
              optionFilterProp="children"
              onChange={(value) => setStoresSingle(value)}
              value={storesSingle}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {storeDataSingle &&
                storeDataSingle.map(({ id, name }) => (
                  <Option key={id} value={id}>
                    {name}
                  </Option>
                ))}
            </Select>
          </div>
        </div>
        <div className="col-md-4 my-5">
          <div className="d-flex" style={{ flexDirection: "column" }}>
            <label>Select Stock</label>
            <Select
              showSearch
              placeholder="Select Quantity"
              optionFilterProp="children"
              onChange={(value) => setCount(value)}
              //   onSearch={onSearch}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              <Option value={0}>0</Option>
              <Option value={1}>1</Option>
              <Option value={2}>2</Option>
              <Option value={3}>3</Option>
              <Option value={4}>4</Option>
              <Option value={5}>5</Option>
              <Option value={6}>6</Option>
              <Option value={7}>7</Option>
              <Option value={8}>8</Option>
              <Option value={9}>9</Option>
              <Option value={10}>10</Option>
            </Select>
          </div>
        </div>

        <div className="col-md-4" style={{ marginTop: "3.4rem" }}>
          <button
            className="btn btn-primary"
            onClick={searchStock}
            disabled={searchLoading}
          >
            Search
            {searchLoading && (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            )}
          </button>
          {pullButtonShow && (
            <button
              className="btn btn-primary ml-3"
              onClick={getStockPrductAvailabilityUpdate}
              disabled={pullLoading}
            >
              Pull stock from Retail{" "}
              {pullLoading && (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
            </button>
          )}
        </div>
      </div>
      {dataTable && (
        <TableComponent
          columns={columns}
          data={data}
          lists={storeWiseListData}
          hideAddButton={true}
          csv={true}
          excelHeader={headers}
          filename={"Low Stock.csv"}
        />
      )}
    </div>
  );
}
